// extracted by mini-css-extract-plugin
export default {"btop":"_03d319fed9 ac435ff00c _1a83847257","icon":"_414168e6c0 b6d3bba6b7","btoppink":"d6b4ce6905 _171d57a391"};